import { infer as Infer, z } from 'zod';

export const userPublicSchema = z.object({
  id: z.number(),
  lvl: z.number(),
  name: z.string(),
  surname: z.string(),
  email: z.email().toLowerCase().trim(),
  avatarURL: z.string().nullable(),
});

export type UserPublicSchema = Infer<typeof userPublicSchema>;

export const userPublicToId = z.codec(userPublicSchema, z.number().int().positive(), {
  decode: (user) => user.id,
  encode: () => {
    throw new Error('Cannot encode an id back to a UserPublic');
  },
});
